import { render } from "./DataBlockForm.vue?vue&type=template&id=4d7036ce"
import script from "./DataBlockForm.vue?vue&type=script&lang=js"
export * from "./DataBlockForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__